/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { showDrivableNoModal } from '../../../actions/modalActions';
import { setTimeShow, getClaimDamagePhotoTypes, handleNextStep, handleStepBack, setFNOLDrivable, setStep } from '../../../actions/claimSubmitActions';
import { isMobile } from 'react-device-detect';
import { FNOL_CLAIM_PROGRESS_MOBILE } from '../../../routes/routes';
import { navigateTo } from '../../../actions/navigationActions';

class FnolStep4Sub1 extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
        }
        this.handleIsDrivableYes = this.handleIsDrivableYes.bind(this);
        this.checkMobileRedirect = this.checkMobileRedirect.bind(this);
    }

    async handleIsDrivableYes() {
        if (!this.props.claimSubmit.hasDamageSelected) {
            if (this.props.claimSubmit.isCar) {
                await this.props.handleGetClaimDamagePhotoTypese(6);
            }
            else {
                await this.props.handleGetClaimDamagePhotoTypese(7);
            }
        }
        await this.props.handleSetFNOLDrivable(true);
        await this.props.dispatchHandleNextStep();
        this.checkMobileRedirect();
    }

    checkMobileRedirect() {
        if (isMobile && (this.props.claimSubmit.lastCompletedStep > (this.props.claimSubmit.selectedClaimStep.step))) {
            this.props.redirectTo(FNOL_CLAIM_PROGRESS_MOBILE);
            this.props.dispatchSetStep(this.props.claimSubmit.lastCompletedStep, this.props.claimSubmit.lastCompletedSubStep);
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    public render() {

        return (<div className="col ssp-container-fnol-drivable ssp-container-fnol-step-header-padding">
            <div className="row noma">
                <div className="col-12 nopa ssp-header-fnol-drivable">
                    <div className="row noma">
                        <div className="fnol-step-header-icon-area">
                            <img src={'/my-policy/Images/Claims/Numbers/number-' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red-32x32px.svg'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                        </div>
                        <div className="col fnol-step-header-title-area">
                            {this.props.claimSubmit.isCar && <h3>Is your car drivable</h3>}
                            {!this.props.claimSubmit.isCar && <h3>Is your motorbike ridable</h3>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row noma">
                <div className="col-12 fnol-steps-info-section-holder">
                    <hr className="hr-minus21px" />

                    {/* /// CAR SPECIFIC CONTENT + BUTTONS /// */}
                    {
                        (this.props.claimSubmit.isCar) &&
                        <>
                            <div className="fnol-drivable-notes-section">
                                <p>
                                        <strong>'Drivable' </strong>
                                        means you can drive your car without causing it more damage, or putting yourself at risk.
                                    </p>
                                <p>
                                        <strong>Please note: </strong>
                                        If there's even 1 requirement on this list that your car doesn't meet, it's not drivable.
                                    </p>
                            </div>
                            <div className="fnol-drivable-bulletlist-section">
                                <span className="fnol-drivable-bulletlist-intro">Your car is drivable if:</span>
                                <ul>
                                    <li>It isn't smoking or leaking oil.</li>
                                    <li>There are no flashing engine lights. You'll need to switch on your car to check this.</li>
                                    <li>The tyres are all aligned.</li>
                                    <li>The break lights are working and the window glass is still intact.</li>
                                    <li>There are no knocks or clicks coming from the engine.</li>
                                    <li>All doors (including the boot) can open.</li>
                                    <li>The driver's airbag didn't deploy.</li>
                                </ul>
                            </div>
                            <div className="col-12 nopa fnol-drivable-buttonholder">
                                <button className="btn btn-solid-red fnol-drivable-button-yes" onClick={this.handleIsDrivableYes}>Yes, I can drive my car</button>
                                <button className="btn btn-outline-red fnol-drivable-button-no" onClick={this.props.handleNotDrivableModal}>No, I can't drive my car</button>
                            </div>
                        </>
                    }
                    {/* /// MOTORBIKE SPECIFIC CONTENT + BUTTONS /// */}
                    {
                        (!this.props.claimSubmit.isCar) &&
                        <>
                            <div className="fnol-drivable-notes-section">
                                <p>
                                    <strong>'Ridable' </strong>
                                    means you can ride your motorbike without causing it more damage, or putting yourself at risk.
                                </p>
                                <p>
                                    <strong>Please note: </strong>
                                    If there's even 1 requirement on this list that your motorbike doesn't meet, it's not ridable.
                                 </p>
                            </div>
                            <div className="fnol-drivable-bulletlist-section">
                                <span className="fnol-drivable-bulletlist-intro">Your motorbike is ridable if:</span>
                                <ul>
                                    <li>The wheels aren't wobbly.</li>
                                    <li>The front forks aren't gouged or bent.</li>
                                    <li>The handlebars aren't bent or crooked.</li>
                                    <li>The petrol tank isn't scratched, dented or leaking.</li>
                                    <li>The frame isn't bent.</li>
                                    <li>The windshield isn't broken or cracked.</li>
                                </ul>
                            </div>
                            <div className="col-12 nopa fnol-drivable-buttonholder">
                                <button className="btn btn-solid-red fnol-drivable-button-yes" onClick={this.handleIsDrivableYes}>Yes, I can ride my motorbike</button>
                                <button className="btn btn-outline-red fnol-drivable-button-no" onClick={this.props.handleNotDrivableModal}>No, I can't ride my motorbike</button>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetTimeShow: () => dispatch(setTimeShow()),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchHandleStepBack: () => dispatch(handleStepBack()),
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        handleNotDrivableModal: () => dispatch(showDrivableNoModal()),
        handleSetFNOLDrivable: (isDriveable) => dispatch(setFNOLDrivable(isDriveable)),
        handleGetClaimDamagePhotoTypese: (productCode) => dispatch(getClaimDamagePhotoTypes(productCode)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FnolStep4Sub1)